import { render } from './core/html.js';
import { HomePage } from './pages/home.js';
import { GamesPage } from './pages/games.js';
import { ServicesPage } from './pages/services.js';
import { LabPage } from './pages/lab.js';
import { BlogPage } from './pages/blog.js';
import { BlogPostPage } from './pages/blogPost.js';
import { PressPage } from './pages/press.js';
import { SustainabilityPage } from './pages/sustainability.js';
import { ContactPage } from './pages/contact.js';
import { ImprintPage } from './pages/imprint.js';
import { PrivacyPage } from './pages/privacy-policy.js';
import { TermsPage } from './pages/terms-of-service.js';
import { posts, postPath } from './data/posts.js';

/**
 * The single route table. `path` is locale-independent; `meta` selects the
 * `meta.<name>.*` copy. Blog posts are derived from `data/posts.js`: their
 * `meta` is `post` and `post` names the slug, so title and description come
 * from `post.<slug>.*` instead. A view may be async; the router and the
 * prerenderer both await it. The build prerenders every route for every locale
 * from this list, and the sitemap is derived from it.
 */
export const ROUTES = [
  { path: '/', meta: 'home', view: () => render(HomePage()) },
  { path: '/games', meta: 'games', view: () => render(GamesPage()) },
  { path: '/lab', meta: 'lab', view: () => render(LabPage()) },
  { path: '/services', meta: 'services', view: () => render(ServicesPage()) },
  { path: '/blog', meta: 'blog', view: () => render(BlogPage()) },
  ...posts.map((post) => ({
    path: postPath(post),
    meta: 'post',
    post: post.slug,
    view: async () => render(await BlogPostPage(post)),
  })),
  { path: '/press', meta: 'press', view: () => render(PressPage()) },
  { path: '/sustainability', meta: 'sustainability', view: () => render(SustainabilityPage()) },
  { path: '/contact', meta: 'contact', view: () => render(ContactPage()) },
  { path: '/imprint', meta: 'imprint', view: () => render(ImprintPage()) },
  { path: '/privacy-policy', meta: 'privacy', view: () => render(PrivacyPage()) },
  { path: '/terms-of-service', meta: 'terms', view: () => render(TermsPage()) },
];
